<template>
  <!-- v-app se mantiene mientras existan pantallas con Vuetify (v-dialog/v-menu lo requieren) -->
  <v-app>
    <AppSidebar
      :visible="drawer"
      :collapsed="collapsed"
      :current-name="$route.name"
      :user-name="userName"
      @close="drawer = false"
      @toggle-collapse="collapsed = !collapsed"
      @expand="collapsed = false"
      @logout="confirmLogout = true"
    />

    <div class="min-h-screen bg-[#f3f5f8] transition-[padding] duration-300" :class="collapsed ? 'lg:pl-16' : 'lg:pl-64'">
      <!-- Barra mínima: solo el acceso al menú en móvil. En desktop el sidebar basta. -->
      <div class="hbox sticky top-0 z-20 h-[52px] items-center gap-2 border-b border-[#e2e8ef] bg-white px-3 lg:hidden">
        <button
          type="button"
          class="rounded-lg p-2 text-[#12304f] transition-colors hover:bg-[#eaf2fb]"
          data-testid="menu-btn-mobile"
          aria-label="Abrir menú"
          :aria-expanded="String(drawer)"
          @click="drawer = true"
        >
          <AppIcon name="bars-3" />
        </button>
        <span class="truncate text-sm font-semibold text-[#12304f]" data-testid="header-title">{{ title }}</span>
      </div>

      <main>
        <router-view></router-view>
      </main>
    </div>

    <BaseModal :visible="confirmLogout" title="Cerrar sesión" @close="confirmLogout = false">
      <p class="text-sm text-gray-600">¿Seguro que deseas salir de Automotriz RM?</p>
      <template #footer>
        <button
          type="button"
          class="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100"
          data-testid="cancel-logout"
          @click="confirmLogout = false"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700"
          data-testid="confirm-logout"
          @click="logOut"
        >
          Cerrar sesión
        </button>
      </template>
    </BaseModal>
  </v-app>
</template>

<script>
/*
 * Sistema — shell de la aplicación (layout de /menu).
 *
 * El header de escritorio se eliminó: las pantallas ya traen su propia barra y
 * el menú lateral indica la sección activa. En móvil queda una barra mínima con
 * el botón de menú y la sección actual.
 *
 * Contratos preservados:
 * - <v-app> presente (lo necesitan los v-dialog/v-menu de Vuetify)
 * - sesión en sessionStorage ('sesion' / 'token')
 * - logout: limpiar sessionStorage y redirigir a '/'
 */
import AppSidebar from '@/components/shell/AppSidebar.vue'
import AppIcon from '@/components/ui/AppIcon.vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { labelForRoute } from '@/components/shell/nav-items'
import { hardRedirect } from '@/utils/navigation'

export default {
  name: 'Sistema',
  components: { AppSidebar, AppIcon, BaseModal },
  data() {
    return {
      drawer: false,
      collapsed: false,
      confirmLogout: false,
      sesion: JSON.parse(sessionStorage.getItem('sesion') || 'null'),
    }
  },
  computed: {
    userName() {
      return (this.sesion && this.sesion.name) || 'Usuario'
    },
    title() {
      return labelForRoute(this.$route.name)
    },
  },
  mounted() {
    // Al girar una tablet, el drawer no debe seguir mostrando etiquetas en
    // la barra contraída de escritorio. Usar el mismo corte que el CSS (lg).
    this.desktopMedia = window.matchMedia('(min-width: 1024px)')
    this.closeDesktopDrawer(this.desktopMedia)
    if (this.desktopMedia.addEventListener) {
      this.desktopMedia.addEventListener('change', this.closeDesktopDrawer)
    } else {
      this.desktopMedia.addListener(this.closeDesktopDrawer)
    }
  },
  beforeDestroy() {
    if (this.desktopMedia.removeEventListener) {
      this.desktopMedia.removeEventListener('change', this.closeDesktopDrawer)
    } else {
      this.desktopMedia.removeListener(this.closeDesktopDrawer)
    }
  },
  methods: {
    closeDesktopDrawer(media) {
      if (media.matches) this.drawer = false
    },
    logOut() {
      sessionStorage.clear()
      hardRedirect('/')
    },
  },
}
</script>
